<template>
  <div class="sms" ref="smsDOM">
    <!-- 头部查询内容 -->
    <div class="header">
      <!-- 左侧 -->
      <a-radio-group
        @change="e => changeDate(e.target.value)"
        class="left"
        size="mini"
        v-model:value="query.dateType"
        button-style="solid"
      >
        <a-radio-button value="day">近7天</a-radio-button>
        <a-radio-button value="month">近1月</a-radio-button>
        <a-radio-button value="all">全部</a-radio-button>
      </a-radio-group>
      <!-- 右侧 -->
      <div class="right">
        <a-checkbox
          @change="e => changeCurWorkID(e.target.checked)"
          v-model:checked="query.isCurWorkID"
        >
          当前工单沟通记录
        </a-checkbox>
        <a-select
          allowClear
          size="mini"
          @change="onPageOrSize({ current: 1 })"
          class="select"
          placeholder="全部角色"
          v-model:value="query.receivePersonRole"
          :options="roleOptions.filter(f => [null, 1, 2, 3, 4].includes(f.value))"
        ></a-select>
        <a-select
          class="select"
          allowClear
          size="mini"
          @change="onPageOrSize({ current: 1 })"
          placeholder="全部发送状态"
          v-model:value="query.sendStatus"
          :options="sendOptions"
        ></a-select>
        <!-- NOTE:这个展示不现实 -->
        <a-select
          class="select"
          size="small"
          v-if="false"
          allowClear
          @change="onPageOrSize({ current: 1 })"
          placeholder="全部触达状态"
          v-model:value="query.readStatus"
          :options="readOptions"
        ></a-select>
      </div>
    </div>
    <div class="body-table">
      <a-table
        ref=""
        class="my-table"
        @showSizeChange="onPageOrSize"
        :rowKey="record => record.id"
        @change="onPageOrSize"
        :pagination="query.pagination"
        :transformCellText="({ text }) => text ?? '--'"
        :columns="columns"
        :data-source="tableData"
        :scroll="{ x: 100, y: 'calc(100vh - 300px)' }"
      >
        <template #sendPerson="{ record }">
          <RoleTag :role="record.sendPersonRole">
            {{ record.sendPerson }}
          </RoleTag>
        </template>
        <template #receivePerson="{ record }">
          <RoleTag :role="record.receivePersonRole">
            {{ record.receivePerson }}
          </RoleTag>
        </template>
        <template #sendStatus="{ record }">
          <a-tag v-if="record.sendStatus" color="success">发送成功</a-tag>
          <a-tag v-else color="error">发送失败</a-tag>
        </template>
        <template #smsInfo="{ text }">
          <a-tooltip
            :getPopupContainer="() => smsDOM"
            overlayClassName="my-tooltip"
            placement="bottom"
            class="two-line"
          >
            <template #title>{{ text }}</template>
            <div class="tooltip-body">
              {{ text }}
            </div>
          </a-tooltip>
        </template>
        <template #mainRelatedWorkOrder="{ text }">
          <a-button v-if="text" size="small" type="link" @click="onOperation(text)">
            {{ text }}
          </a-button>
          <span v-else>--</span>
        </template>
      </a-table>
    </div>
    <PatientInfoDetails
      @handleCancel="handleCancel"
      :showAllDialog="dialog.show"
      :currentInfo="dialog.info"
    />
  </div>
</template>
<script setup>
import RoleTag from './RoleTag'
import PatientInfoDetails from '@/components/PatientInfoDetails'
import { computed, onMounted, reactive, ref, defineProps } from 'vue'
import { readOptions, sendOptions, roleOptions, columns } from './config'
import moment from 'moment'
import { getSMSInfo } from '@/api/workPlace/SMS'
import { useStore } from 'vuex'
import { getWorkOrderListAsyn as getWorkOrderListAsync, getWorkOrderListByTaskId } from '@/api/Todo'
import { message } from 'ant-design-vue'
const store = useStore()
const smsDOM = ref()
const tableData = ref([])
const query = reactive({
  // NOTE:下面是查询条件
  dateType: 'all',
  isCurWorkID: false,
  // 0-未读 1-巳读
  readStatus: null,
  // 0 系统” 1患者 2 医生 3BD 4医生助手 5合作医院 6cms 7“医生学生
  receivePersonRole: null,
  // 0-失败 1-成功
  sendStatus: null,
  workOrderId: null,
  sendStartTime: null,
  sendEndTime: null,
  // 页码
  pagination: {
    current: 1,
    pageSize: 10,
    showQuickJumper: true,
    showSizeChanger: true,
    total: 100,
    size: 'small',
    showTotal: total => `共 ${total} 条`
  }
})
const dialog = reactive({
  show: false,
  info: {}
})
async function onOperation(data) {
  // 最多执行10次
  let loopCount = 0
  const loopFetch = () => {
    // 第十次跳出（实际第11次 0 开始）
    if (loopCount === 10) return
    setTimeout(async () => {
      const resultWork = await getWorkOrderListByTaskId({ taskId })
      const list = resultWork.list
      if (list && list.length > 0) {
        workOrder = list[0]
        dialog.show = true
        dialog.info = workOrder
      } else if (list?.length === 0) {
        const errMsg = `工单ID${data}不存在或暂无查看权限`
        message.error(errMsg)
      } else {
        loopFetch()
        loopCount++
      }
    }, 100)
  }
  const params = {
    workOrderIdList: [data],
    curPage: 1,
    pageSize: 10,
    allocateTimeStart: '',
    allocateTimeEnd: '',
    completeTimeStart: '',
    completeTimeEnd: '',
    dealTimeStart: '',
    dealTimeEnd: '',
    createTimeStart: '',
    createTimeEnd: '',
    unAllocatedFlag: null
  }
  // 循环后去数据
  let workOrder
  const result = await getWorkOrderListAsync(params)
  const { taskId, list } = result
  // 如果有数据直接渲染，没有数据拿 taskID 去轮训
  if (list && list.length) {
    workOrder = list[0]
    dialog.show = true
    dialog.info = workOrder
  } else if (taskId) {
    loopFetch()
  } else {
    const errMsg = `工单ID${data}不存在或暂无查看权限`
    message.error(errMsg)
  }
}
function getData() {
  const params = {
    doctorUcId: doctorUcId.value,
    patientUcId: patientUcId.value,
    readStatus: query.readStatus,
    receivePersonRole: query.receivePersonRole,
    sendStatus: query.sendStatus,
    workOrderId: query.workOrderId,
    sendStartTime: query.sendStartTime,
    sendEndTime: query.sendEndTime,
    pageNo: query.pagination.current,
    pageSize: query.pagination.pageSize
  }
  tableData.value = []
  getSMSInfo(params).then(result => {
    const { list, totalCount } = result
    query.pagination.total = totalCount
    tableData.value = list
  })
}
// 改变当前页 和 改变页码值
function onPageOrSize({ current, pageSize }) {
  query.pagination.pageSize = pageSize || query.pagination.pageSize
  query.pagination.current = current
  getData()
}
function changeDate(type) {
  const formatSTR = 'YYYY-MM-DD'
  const typeMap = {
    day() {
      query.sendStartTime = moment().subtract(7, 'day').format(formatSTR)
      query.sendEndTime = moment().format(formatSTR)
    },
    month() {
      query.sendStartTime = moment().subtract(1, 'month').format(formatSTR)
      query.sendEndTime = moment().format(formatSTR)
    },
    all() {
      query.sendStartTime = null
      query.sendEndTime = null
    }
  }
  typeMap[type]()
  getData()
}
const workOrderID = computed(() => {
  const id = prop.isComponent
    ? prop.workOrderId
    : store.state.workOrder.workOrderGroupInfo.targetWorkOrder.workOrderId
  return id
})
const doctorUcId = computed(() => {
  const id = prop.isComponent
    ? prop.ucDoctorId
    : store.state.workOrder.workOrderGroupInfo.doctorInfo.ucUserId
  return id
})
const patientUcId = computed(() => {
  const id = prop.isComponent
    ? prop.ucUserId
    : store.state.workOrder.workOrderGroupInfo.patientInfo.ucUserId
  return id
})
function changeCurWorkID(is) {
  query.workOrderId = is ? workOrderID.value : null
  getData()
}
function handleCancel() {
  dialog.show = false
}
onMounted(() => {
  onPageOrSize({ current: 1, pageSize: 10 })
})
// 兼容传入的参数
const prop = defineProps({
  ucDoctorId: { type: String, default: '' },
  ucUserId: { type: String, default: '' },
  workOrderId: { type: String, default: '' },
  isComponent: { type: Boolean, default: false }
})
</script>
<style lang="scss" scoped>
.sms {
  padding: 20px;
  height: 100%;
  .header {
    margin-bottom: 12px;
    display: flex;
    justify-content: space-between;
    .right {
      .select {
        width: 220px;
        margin-right: 12px;
        &:last-child {
          margin: 0;
        }
      }
    }
  }
  .body-table {
    background-color: white;
    padding: 12px 12px 0;
    ::v-deep(.my-table) {
      // display: block;
      .two-line {
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }
  // 黑色弹出的提示内容框 样式
  ::v-deep(.my-tooltip) {
    .ant-tooltip-content {
      .ant-tooltip-inner {
        border-radius: 4px;
      }
    }
  }
}
</style>
